<template>
	<div class="import">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h3>Check Products</h3>

		<div class="radioCheck">
			<b-radio v-model="checkItem" name="name" native-value="bdcode">
				BD Code
			</b-radio>
			<b-radio v-model="checkItem" name="name" native-value="barcode">
				Barcode
			</b-radio>
		</div>
		<label class="csv-reader">
			<input type="file" @change="loadTextFromFile" />
		</label>

		<div class="check-results">
			<div v-if="invalidCode.length > 0">
				<h1>INVALID PRODUCTS</h1>
				<div v-for="(code, key) of invalidCode" :key="key">
					<p>{{ code }}</p>
				</div>
			</div>

			<div v-if="validCode.length > 0">
				<h1>VALID PRODUCTS</h1>
				<div v-for="(code, key) of validCode" :key="key">
					<p>{{ code }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'productsCheck',
	data: () => ({
		isLoading: false,
		name: null,
		bdcode: [],
		invalidCode: [],
		validCode: [],
		checkItem: 'bdcode'
	}),
	mounted: function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}
	},
	watch: {},
	methods: {
		// Verify if the brand ID and values are valid
		verifyContent: async function(toCheckData) {
			this.isLoading = true
			// await new Promise(r => setTimeout(r, 50));

			var data = {}

			if (this.checkItem == 'bdcode') {
				data.bd_code = toCheckData
			} else {
				data.barcode = toCheckData
			}

			const apiBuyGetProduct = await this.$api.checkProducts({
				data
			})

			if (apiBuyGetProduct == undefined) {
				this.invalidCode.push(toCheckData)
			} else {
				this.validCode.push(toCheckData)
			}
		},

		// Load CSV and add into array
		loadTextFromFile(ev) {
			const file = ev.target.files[0]
			const reader = new FileReader()

			// reader.onload = e => this.$emit("load", e.target.result);
			reader.onload = event => {
				var raw = event.target.result.split(/\r?\n/)

				var toCheck

				var header = raw[0].split(/,/)

				// Check the right column
				if (this.checkItem == 'bdcode') {
					toCheck = header.indexOf('BD CODE')
				} else {
					toCheck = header.indexOf('BARCODE')
				}

				if (toCheck == -1) {
					this.$swal.fire('Cannot find header ' + this.checkItem)

					this.isLoading = false

					return
				}

				// Remove first row
				raw.shift()
				// Loop every row to put it in array
				raw.map(async data => {
					this.isLoading = true
					var splitData = data.split(/,/)

					if (splitData[toCheck]) {
						await this.verifyContent(splitData[toCheck])
					}
				})

				this.isLoading = false
			}

			reader.readAsText(file)
			this.isLoading = false
		}
	}
}
</script>

<style scoped>
@import '../styles/Import.css';
</style>
